import GaugeDial from '../../plots/GaugeDial';
import { useAppStateContext } from '../../../hooks/useAppState';
import FadeTransition from '../../widgetsAndUtils/FadeTransition';

// MPI Comparison Panel - pretty much only shows comparison gauge underneath the main MPI plots
export default function MPIComparisonPanel() {
  const { state, bmpState } = useAppStateContext();
  const mpiComparisonData = state.mpiComparisonData || [];
  const comparisonMode = state.mpiComparisonMode;

  const analysistype = bmpState.analysistype;
  
  // Get comparison BMP label from actual data
  const getComparisonBmpLabel = () => {
    // Look for comparison data in WQ or Hydrology data to get the actual BMP name
    const wqComparisonData = Object.values(state.wq.indexData).find(analyteData => 
      analyteData.index_summary?.some(d => d.bmp?.startsWith('Other'))
    );
    
    const hydrologyComparisonData = state.hydrology.indexData?.index_summary?.find(d => 
      d.bmp?.startsWith('Other')
    );
    
    // Use the actual BMP name from the data
    if (wqComparisonData) {
      const comparisonEntry = wqComparisonData.index_summary.find(d => d.bmp?.startsWith('Other'));
      if (comparisonEntry?.bmp) {
        return comparisonEntry.bmp;
      }
    }
    
    if (hydrologyComparisonData?.bmp) {
      return hydrologyComparisonData.bmp;
    }
    
    // Fallback
    return 'Other BMPs';
  };
  
  // Only show if comparison mode is enabled, analysistype is individual, and we have comparison data
  const hasValidComparisonWeight = mpiComparisonData.length > 0 && mpiComparisonData.some(d => !isNaN(d.weight));
  const overallComparisonIndex = mpiComparisonData.reduce(
    (sum, d) => (!isNaN(d.weight) && !isNaN(d.score)) ? sum + d.weight * d.score : sum,
    0
  );

  // Determine if comparison should be shown
  const shouldShowComparison = analysistype === 'individual' && comparisonMode && hasValidComparisonWeight;

  return (
    <FadeTransition
      in={shouldShowComparison}
      timeout={500}
      unmountOnExit
    >
      <div className="flex flex-col items-center">
        <h4 className="text-md font-semibold mb-2 text-center">{getComparisonBmpLabel()}</h4>
        <GaugeDial value={overallComparisonIndex} />
      </div>
    </FadeTransition>
  );
} 